import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Project } from '../../../dtos/project';
import { ProjectRole } from '../../../dtos/project-role';
import {
  formatStageState,
  getStageStateClass,
  stageToChildRoute,
} from '../../../dtos/project-state';

@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.scss',
})
export class ProjectCardComponent {
  @Input() project!: Project;
  @Input() userRole?: ProjectRole | null;
  @Input() canEdit = false;

  @Input() isInline = false;
  @Input() paperCount = 0;
  @Output() viewDetails = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() leaveProject = new EventEmitter<Project>();

  constructor(private router: Router) {}

  onClickCard(): void {
    const route = stageToChildRoute(this.project.state);
    const segments = route ? ['/projects', this.project.id, route] : ['/projects', this.project.id];
    this.router.navigate(segments);
  }

  onLeaveProject(event: MouseEvent): void {
    event.stopPropagation();

    if (!this.project) {
      return;
    }

    this.leaveProject.emit(this.project);
  }

  canLeaveProject(): boolean {
    return !!this.userRole && this.userRole.role === 'RESEARCHER';
  }

  getStateClass(): string {
    return getStageStateClass(this.project?.state);
  }

  getRoleClass(): string {
    return 'badge-primary';
  }

  formatState(state: string): string {
    if (state === 'SETUP' || state === 'INGESTION') return 'Setup / Ingestion';
    return formatStageState(state);
  }
}
